import { memo } from "react";

import styles from "./styles.module.css";

type ThemedLogsAnsiContentProps = {
  text: string;
  searchText: string;
  lineIndex: number;
  currentOccurrenceIndex: number | undefined;
  searchOccurrences: { lineIndex: number; occurrenceIndex: number }[];
};

const ThemedLogsHighlightedText = ({
  text,
  searchText,
  lineIndex,
  currentOccurrenceIndex,
  searchOccurrences,
}: ThemedLogsAnsiContentProps) => {
  if (!searchText.trim()) {
    return <span>{text}</span>;
  }

  const search = searchText.toLowerCase();
  const lowerText = text.toLowerCase();
  let result = "";
  let lastIndex = 0;
  let replacementIndex = 0;

  // Find all occurrences of the search text
  let currentIndex = 0;
  while (currentIndex < lowerText.length) {
    const foundIndex = lowerText.indexOf(search, currentIndex);
    if (foundIndex === -1) break;

    // Add text before the match
    result += text.slice(lastIndex, foundIndex);

    // Check if this occurrence should be highlighted as active
    const currentOccurrence = searchOccurrences.find(
      (occ) => occ.lineIndex === lineIndex && occ.occurrenceIndex === replacementIndex
    );
    const isActive =
      currentOccurrenceIndex !== undefined &&
      currentOccurrence &&
      searchOccurrences[currentOccurrenceIndex] &&
      searchOccurrences[currentOccurrenceIndex].lineIndex === lineIndex &&
      searchOccurrences[currentOccurrenceIndex].occurrenceIndex === replacementIndex;

    // Add the highlighted match
    const match = text.slice(foundIndex, foundIndex + search.length);
    result += `<mark class="highlight ${isActive ? styles.active : ""}">${match}</mark>`;

    replacementIndex++;
    lastIndex = foundIndex + search.length;
    currentIndex = foundIndex + 1;
  }

  // Add remaining text
  result += text.slice(lastIndex);

  return <span dangerouslySetInnerHTML={{ __html: result }} />;
};

export default memo(ThemedLogsHighlightedText);
